import { render, staticRenderFns } from "./WholesaleBillInfo.vue?vue&type=template&id=552864b4"
import script from "./WholesaleBillInfo.vue?vue&type=script&lang=js"
export * from "./WholesaleBillInfo.vue?vue&type=script&lang=js"
import style0 from "./WholesaleBillInfo.vue?vue&type=style&index=0&id=552864b4&prod&lang=css"
import style1 from "./WholesaleBillInfo.vue?vue&type=style&index=1&id=552864b4&prod&lang=scss"
import style2 from "./WholesaleBillInfo.vue?vue&type=style&index=2&id=552864b4&prod&lang=scss"
import style3 from "./WholesaleBillInfo.vue?vue&type=style&index=3&id=552864b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports